import { render, staticRenderFns } from "./InjuryMomentChart.vue?vue&type=template&id=617d0d09&scoped=true"
import script from "./InjuryMomentChart.vue?vue&type=script&lang=js"
export * from "./InjuryMomentChart.vue?vue&type=script&lang=js"
import style0 from "./InjuryMomentChart.vue?vue&type=style&index=0&id=617d0d09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617d0d09",
  null
  
)

export default component.exports